// $(document).ready(function() {
//     $('a[href="https://shop.zollipops.com/customer_authentication/redirect?locale=en&region_country=US"]').attr('target','_blank');

// });
// $(document).ready(function() {
//     $('a[href="https://www.shopify.com?utm_campaign=poweredby&utm_medium=shopify&utm_source=onlinestore"],a[href="https://www.federalregister.gov/documents/2007/09/17/E7-18196/food-labeling-health-claims-dietary-noncariogenic-carbohydrate-sweeteners-and-dental-caries#:~:text=Therefore%2C%20FDA%20has%20concluded%20that,substance%20eligible%20for%20the%20claim"],a[href="https://www.govinfo.gov/app/details/FR-1996-08-23/96-21481#:~:text=%2D205%2D5916.-,Summary,the%20nonpromotion%20of%20dental%20caries"],a[href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9261844/#:~:text=Isomalt%20on%20average%20has%2045,levels%20%5B9%2C30%5D"],a[href="https://www.regulations.gov/document/FDA-2016-P-4275-0057"],a[href="https://journalofmetabolichealth.org/index.php/jmh/article/view/32/97"],a[href="https://pubmed.ncbi.nlm.nih.gov/28140467/"],a[href="https://www.foodallergy.org/our-initiatives/awareness-campaigns/living-teal/teal-pumpkin-project"],a[href="https://www.epilepsy.com/volunteer/fundraising/purple-pumpkin-project"],a[href="https://www.matherhospital.org/care-treatment/fortunato-breast-health-center/pink-your-pumpkin/"],a[href="https://www.autismspeaks.org/halloween"]').each(function() {
//         var originalTitle = $(this).text();
        
//         // Set aria-label to the full original title, no trimming
//         $(this).attr('aria-label', originalTitle + ' (open in a new window)');
        
//         $(this).attr('target', '_blank'); // Open link in a new tab/window
//         $(this).removeAttr('title'); // Remove the title attribute
//     });
// });

$(document).ready(function() {
  
    $('a').each(function () {
        // Check if the link is external
        if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'https://shop.zollipops.com/') {
          // Create a span element with warning text
          var warningSpan = $('<span class="visuallyhidden">: This link will open in a new tab.</span>');
          // Set attributes for accessibility
          $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
          // Append the warning span inside the link
          $(this).append(warningSpan);
        }
      });
        });

document.addEventListener('DOMContentLoaded', function () {
    // Function to add the <span> element
    function addVisuallyHiddenSpan() {
        document.querySelectorAll('.instafeed-new-layout-item a').forEach(function (anchor) {
            // Check if the span already exists to avoid duplication
            if (!anchor.querySelector('.visually-hidden')) {
                const hiddenSpan = document.createElement('span');
                hiddenSpan.className = 'visually-hidden';
                hiddenSpan.textContent = 'this link will open in new tab';
                anchor.appendChild(hiddenSpan);
            }
        });
    }

    // Use MutationObserver to monitor DOM changes
    const observer = new MutationObserver(function (mutationsList) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // Check if .instafeed-new-layout-item is added
                if (document.querySelector('.instafeed-new-layout-item')) {
                    addVisuallyHiddenSpan();
                }
            }
        }
    });

    // Start observing the body for child element additions
    observer.observe(document.body, { childList: true, subtree: true });

    // Initial check in case elements are already loaded
    addVisuallyHiddenSpan();
});
